import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SessionService} from '../../services/session.service';
import {LoadingSpinnerService} from '../../services/loading-spinner.service';
import {DialogService} from '../../services/dialog.service';
import {ExceptionDialogComponent} from '../../components/exception-dialog/exception-dialog.component';
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  imports: [
    MatButton,
    MatIcon,
    TranslatePipe
  ],
  styleUrl: './landing-page.component.scss'
})
export class LandingPageComponent {
  constructor(
    activatedRoute: ActivatedRoute,
    loadingSpinnerService: LoadingSpinnerService,
    sessionService: SessionService,
    private readonly router: Router,
    private readonly dialogService: DialogService) {
    sessionService.revokeSession()
    activatedRoute.queryParams.subscribe(params => {
      if (params['exceptionSubject'] && params['exceptionBody']) {
        this.showExceptionModal(params['exceptionSubject'], params['exceptionBody']);
      }
    });
    loadingSpinnerService.hide();
  }

  showExceptionModal(exceptionSubject: string, exceptionBody: string) {
    this.dialogService.open(ExceptionDialogComponent, {
      data: {
        title: exceptionSubject,
        message: exceptionBody
      }
    });
  }

  login() {
    this.router.navigate(['login']).then();
  }
}
